const testHandle = (id: string) => (id ? `e2e-${id}` : 'provide-test-id')

export default testHandle
